"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ReplicateFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M960 447.11v101.25H604.66V960H491.4V447.11zm0-191.55v101.43H390.85V960H277.62V255.56zM960 64v101.43H177.27V960H64V64z" } }] }, "name": "replicate", "theme": "filled" };
exports.default = ReplicateFilled;
